import { render, staticRenderFns } from "./publishGoodsModal.vue?vue&type=template&id=03669bd6&scoped=true"
import script from "./publishGoodsModal.vue?vue&type=script&lang=js"
export * from "./publishGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./publishGoodsModal.vue?vue&type=style&index=0&id=03669bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03669bd6",
  null
  
)

export default component.exports